export interface RoleInfo {
  title: string;
  items: string[];
}

export const rolesInfoData: RoleInfo[] = [
  {
    title: 'Senior Manager',
    items: [
      'Highest management role',
      'Can manage user departments',
      'Can assign/remove roles: manager, accountant, finance manager',
      'Full access to all sections',
      'Cannot be assigned by any other role',
    ],
  },
  {
    title: 'Manager',
    items: [
      'Manage users (create, deactivate)',
      'Edit non-manager users only',
      'Full order editing (including items)',
      'Manage districts',
      'Access to all manager app sections',
      'Can assign/remove roles: operator, driver, storekeeper',
    ],
  },
  {
    title: 'Operator',
    items: [
      'Basic order operations (view, change status, phone)',
      'Cannot edit order items',
      'Cannot manage users or districts',
      'Limited functionality access',
    ],
  },
  {
    title: 'Driver (Courier)',
    items: ['Role for delivery drivers', 'Access to courier mobile app', 'Performs deliveries'],
  },
  {
    title: 'Auditor',
    items: [
      'Access to all ERP sections',
      'WarehouseList, ShipmentList, MovingList, IncomingList',
      'ProductList (view only)',
      'ReceiptList — VIEW ONLY (no Accept/Reject; mutations blocked)',
      'RecountList — full CRUD (unique role with this access)',
      'Reports: CollectionReport, WarehouseReport',
      'Tracking',
      'Cannot modify/confirm Receipt',
    ],
  },
  {
    title: 'Storekeeper',
    items: [
      'Access to warehouse operational sections only',
      'WarehouseList, ShipmentList, MovingList, IncomingList',
      'ProductList (view only)',
      'No access to: Recount, Receipt, reports, Tracking',
      'Focus on warehouse operations',
    ],
  },
  {
    title: 'Accountant',
    items: [
      'Financial sections',
      'ReceiptList — full CRUD including Accept/Reject',
      'Reports: CollectionReport, WarehouseReport',
      'Tracking',
      'ProductList (view only)',
      'No access to warehouse operational sections (Warehouse, Shipment, Moving, Incoming)',
      'No access to Recount',
      'Focus on financial control and reporting',
    ],
  },
  {
    title: 'Finance Manager',
    items: [
      'Manages company bank accounts and driver-account links',
      'Account / DriverAccount pages — full CRUD',
      'Read access to receipt-related data (sending_method, sending_method_provider)',
      'Typically assigned alongside accountant or auditor',
      'Cannot create or edit receipts',
    ],
  },
  {
    title: 'Senior Operator',
    items: [
      'Intermediate role between Operator and Manager',
      'Can edit orders (including items)',
      'Can manage districts',
      'Can manage all users (create, edit names, deactivate)',
      'Rarely used in system (single user)',
    ],
  },
];
